import { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { TABLE_NAMES } from '../constants';

export const useComments = (postId) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!postId) {
      setComments([]);
      setLoading(false);
      return;
    }

    // Skip database query for mock post IDs (they don't exist in the database)
    if (postId.startsWith('mock')) {
      console.log(`[COMMENTS] Skipping database query for mock post: ${postId}`);
      setComments([]);
      setLoading(false);
      return;
    }

    const fetchComments = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from(TABLE_NAMES.BLOG_COMMENTS)
          .select('*')
          .eq('post_id', postId)
          .order('created_at', { ascending: false });

        if (error) {
          // Only log error if it's not a 400 (which happens for invalid post IDs)
          if (error.code !== 'PGRST116' && error.status !== 400) {
            console.error("[COMMENTS] Error fetching comments:", error);
          }
          setComments([]);
        } else {
          setComments(data || []);
        }
      } catch (error) {
        console.error("[COMMENTS] Exception in fetchComments:", error);
        setComments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchComments();
  }, [postId]);

  return { comments, loading };
};
